// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';
import { useLocation } from 'react-router-dom';

import { SearchResultsProvider } from '@features/searchResults/providers/SearchResultsProvider';
import SearchResultsLanding from '@features/searchResults/components/SearchResultsLanding';
import SearchResultsQuery from '@features/searchResults/components/SearchResultsQuery';

// COMPONENT ---------------------------------------------------------------- //

const SearchResultsPage = () => {
  const location = useLocation();
  const searchInput = location?.state?.searchInput;

  return (
    <SearchResultsProvider>
      {searchInput ? <SearchResultsQuery searchInput={searchInput} /> : <SearchResultsLanding />}
    </SearchResultsProvider>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default SearchResultsPage;
